module.exports = __webpack_public_path__ + "aggregation.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/aggregation.svg?color1=%23333333&color2=
// module id = 2180
// module chunks = 67